import { render, staticRenderFns } from "./buyerLeftBar2.vue?vue&type=template&id=597254be&scoped=true"
import script from "./buyerLeftBar2.vue?vue&type=script&lang=js"
export * from "./buyerLeftBar2.vue?vue&type=script&lang=js"
import style0 from "./buyerLeftBar2.vue?vue&type=style&index=0&id=597254be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597254be",
  null
  
)

export default component.exports